import React from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  isCartOpened,
  isSearchLoading,
  isUserLoggedIn,
  getCurrentPathname,
} from '../store/common'
import { getTranslate, getActiveLanguage } from 'react-localize-redux'

import NavProfile from '../molecules/containers/NavProfile'
import CartInHeader from '../molecules/containers/CartInHeader'
import SearchContainer from '../containers/Search/SearchContainer'
import LanguageSelector from '../molecules/containers/LanguageSelector'

import { toggleCart, toggleMobileSearchBar } from '../store/common'
import {
  Badge, Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import CacheBuster from '../cacheBuster'


class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuIsOpen: false
    }
  }


  render() {
    const {
      currentPage,
      translate,
      isMobileSearchBarOpen,
      toggleMobileSearchBar,
      toggleCart,
      isAdmin,
    } = this.props
    const { menuIsOpen } = this.state;
    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }

          return (
            <React.Fragment>
              <header className='header hidden-md-down'>
                <div className='header__half'>
                  <div className='header__logo'>
                    <Link to='/' />
                  </div>
                  <div className='header__nav'>
                    <Link
                      to='/'
                      className={
                        'header__nav__item ' + (currentPage === '/' ? 'active' : '')
                      }
                    >
                      {translate('header.home')}
                    </Link>
                    <Link
                      to='/orders'
                      className={
                        'header__nav__item ' +
                        (currentPage === '/orders' ? 'active' : '')
                      }
                    >
                      {translate('header.orders')}
                    </Link>
                    <Link
                      to='/sales'
                      className={
                        'header__nav__item ' +
                        (currentPage === '/sales' ? 'active' : '')
                      }
                    >
                      {translate('header.sales')}
                    </Link>
                    {isAdmin && (
                      <Link
                        to='/salesmen'
                        className={
                          'header__nav__item ' +
                          (currentPage === '/salesmen' ? 'active' : '')
                        }
                      >
                        {translate('header.oz')}
                      </Link>
                    )}
                    <Link to='https://www.mobilnet.sk' className='header__nav__item'>
                      Mobilnet.sk
                    </Link>
                    <Link to='#' className='header__nav__item terms'>
                      Terms...
                    </Link>
                    <code>v{global.appVersion}</code>
                  </div>
                </div>
                {currentPage === '/' && (
                  <div className='header__half'>
                    <LanguageSelector />
                    <NavProfile />
                  </div>
                )}
                {currentPage !== '/' && (
                  <div className='header__half'>
                    <LanguageSelector />
                    <NavProfile />
                    {/* <SearchContainer /> */}
                    <CartInHeader />
                  </div>
                )}
              </header>
              <header className='header mobile-header'>
                <div className='header__logo'>
                  <Link to='/' />
                </div>
                <div className='header__nav'>
                  <Dropdown isOpen={menuIsOpen} toggle={() => { this.setState({ menuIsOpen: !menuIsOpen }) }}>
                    <DropdownToggle
                      className={"btn-danger"}
                    >
                      Menu
                    </DropdownToggle>
                    <DropdownMenu>

                      <DropdownItem

                      >
                        <Link to='/'
                          className={
                            'header__nav__item '
                          }>
                          {translate('header.home')}
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link
                          to='/orders'
                          className={
                            'header__nav__item ' +
                            (currentPage === '/orders' ? 'active' : '')
                          }
                        >
                          {translate('header.orders')}
                        </Link>

                      </DropdownItem>
                      <DropdownItem>
                        <Link
                          to='/sales'
                          className={
                            'header__nav__item ' +
                            (currentPage === '/sales' ? 'active' : '')
                          }
                        >
                          {translate('header.sales')}
                        </Link>


                      </DropdownItem>
                      {isAdmin && (
                        <DropdownItem>
                          <Link
                            to='/salesmen'
                            className={
                              'header__nav__item ' +
                              (currentPage === '/salesmen' ? 'active' : '')
                            }
                          >
                            {translate('header.oz')}
                          </Link>
                        </DropdownItem>
                      )}

                      <DropdownItem>
                        <Link to='https://www.mobilnet.sk' className='header__nav__item'>
                          Mobilnet.sk
                        </Link>
                      </DropdownItem>
                                         </DropdownMenu>
                  </Dropdown>
                </div>
                <LanguageSelector />
                <NavProfile />
                {currentPage !== '/' && (
                  <React.Fragment>
                    {/* <div className="header__mobile__search">
                <i
                  className={"fa fa-fw fa-search"}
                  onClick={() => toggleMobileSearchBar()}
                />
              </div> */}

                    <div className='header__mobile__cart'>
                      <i
                        className={'fa fa-fw fa-shopping-cart'}
                        onClick={() => toggleCart()}
                      >
                        {this.props.cartItems.length > 0 && (
                          <Badge color='danger'>{this.props.cartItems.length}</Badge>
                        )
                          // this.props.cartItems
                        }
                      </i>
                    </div>
                    {/* <CartInHeader /> */}
                  </React.Fragment>
                )}
              </header>
              {isMobileSearchBarOpen && (
                <header className='header mobile-header-search-bar'>
                  <SearchContainer />
                </header>
              )}
            </React.Fragment>)
        }}
      </CacheBuster>
    )
  }
}

Header.propTypes = {
  currentPage: PropTypes.string,
  translate: PropTypes.func,
}

const mapStateToProps = state => ({
  isSearchLoading: isSearchLoading(state.common.searchLoading),
  isCartOpened: isCartOpened(state.common.cartOpen),
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  isUserLoggedIn: isUserLoggedIn(state.common.token),
  isMobileSearchBarOpen: state.common.mobileSearchBarOpen,
  currentPage: getCurrentPathname(state.location.pathname),
  isAdmin: state.common.isAdmin,
  cartItems: state.cart.list,
})

const mapDispatchToProps = dispatch => ({
  toggleCart: () => dispatch(toggleCart()),
  toggleMobileSearchBar: () => dispatch(toggleMobileSearchBar()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)



// WEBPACK FOOTER //
// ./src/layouts/Header.js